import { ApiErrorResponse } from '../types/auth';

export function extractApiError(err: unknown, fallback: string): string {
  const apiError = err as ApiErrorResponse;
  return apiError?.message || fallback;
}
